<p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{ title }}" [(visible)]="display" [modal]="true" appendTo="body" [style]="{'width':'680px'}">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
	<div class="container-md">
		<div class="ui-grid-row">
			<div class="ui-grid-col-12">
				@for (msg of messages; track $index) {
					<div class="alert alert-danger">{{ msg.detail }}</div>
				}
			</div>

			<div class="row mt-4 mb-4">
				<div class="col-sm-6 d-flex flex-column">
					<label for="vehicle-version-type" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'control-panel.vehicles.vehicleType' | translate }}
					</label>
					<p-select
						id="vehicle-version-type"
						[options]="vehicleTypeList"
						[(ngModel)]="selectedType"
						(onChange)="typeChanged($event)"
						optionLabel="name"
						dataKey="id"
						placeholder="{{ 'general.select' | translate }}"
						appendTo="body"
						filter="true"
						filterBy="name"
						[style]="{'width':'100%'}"
					></p-select>
				</div>
				<div class="col-sm-6 d-flex flex-column">
					<label for="vehicle-version-brand" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'control-panel.vehicles.vehicleBrand.name' | translate }}
					</label>
					<p-select
						id="vehicle-version-brand"
						[options]="brandList"
						[(ngModel)]="selectedBrand"
						(onChange)="brandChanged($event)"
						optionLabel="name"
						dataKey="id"
						placeholder="{{ 'general.select' | translate }}"
						appendTo="body"
						filter="true"
						filterBy="name"
						[style]="{'width':'100%'}"
					></p-select>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-6 d-flex flex-column">
					<label for="vehicle-version-model" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'control-panel.vehicles.vehicleModel.name' | translate }}
					</label>
					<p-select
						id="vehicle-version-model"
						[options]="modelList"
						[(ngModel)]="selectedModel"
						optionLabel="name"
						dataKey="id"
						placeholder="{{ 'general.select' | translate }}"
						appendTo="body"
						filter="true"
						filterBy="name"
						[style]="{'width':'100%'}"
					></p-select>
				</div>

				<div class="col-sm-6 d-flex flex-column">
					<label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.versions.name' | translate }}
					</label>
					<input
						type="text"
						id="vehicle-data-settings-name"
						class="form-control custom-input"
						[(ngModel)]="entity.name"
					/>
				</div>
			</div>
			<!-- CILINDER CAPACITY & CONSUMPTION -->
			<div class="row mt-4 mb-4">
				<!-- CILINDER CAPACITY INPUT -->
				<div class="col-sm-6">
					<label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.versions.displacement' | translate }}
					</label>
					<div class="input-group">
						<input
							type="number"
							id="vehicle-data-settings-name"
							class="form-control custom-input"
							[(ngModel)]="entity.cylinderCapacity"
						/>
						<span class="input-group-text custom-input-suffix">cc</span>
					</div>
				</div>
				<!-- CONSUMPTION INPUT -->
				<div class="col-sm-6">
					<label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.versions.consumption' | translate }}
					</label>
					<div class="input-group">
						<input
							type="number"
							id="vehicle-data-settings-name"
							class="form-control custom-input"
							[(ngModel)]="entity.consumption"
						/>
						<span class="input-group-text custom-input-suffix">l/100km</span>
					</div>
				</div>
			</div>
			<!-- EMISSIONS & FUEL CAPACITY -->
			<div class="row mt-4 mb-4">
				<!-- EMISSIONS INPUT -->
				<div class="col-sm-6">
					<label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.versions.emissions' | translate }}
					</label>
					<div class="input-group">
						<input
							type="number"
							id="vehicle-data-settings-name"
							class="form-control custom-input"
							[(ngModel)]="entity.emissions"
						/>
						<span class="input-group-text custom-input-suffix">g/km</span>
					</div>
				</div>
				<!-- FUEL CAPACITY INPUT -->
				<div class="col-sm-6">
					<label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.versions.fuelCapatity' | translate }}
					</label>
					<div class="input-group">
						<input
							type="number"
							id="vehicle-data-settings-name"
							class="form-control custom-input"
							[(ngModel)]="entity.fuelCapacity"
						/>
						<span class="input-group-text custom-input-suffix">l</span>
					</div>
				</div>
			</div>

			<!-- FUEL TYPE -->
			<div class="row mt-4 mb-4">
				<!-- FUEL TYPE INPUT -->
				<div class="col-sm-6">
					<label for="type" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.versions.fuelType' | translate }}
					</label>
					<select
						id="vehicle-data-settings-field3"
						[(ngModel)]="entity.fuelType"
						class="form-control custom-input"
					>
						@for (option of optionsFuelType; track option) {
							<option [value]="option.value">{{ option.label }}</option>
						}
					</select>
				</div>

				<!-- CATEGORY -->
				@if (canViewCategory) {
					<div class="col-sm-6 d-flex flex-column">
						<label for="vehicle-version-category" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ 'tableManagement.categories.category' | translate }}
						</label>
						<p-select
							id="vehicle-version-category"
							[options]="categoryList"
							[(ngModel)]="entity.category"
							optionLabel="name"
							dataKey="id"
							placeholder="{{ 'general.select' | translate }}"
							appendTo="body"
							filter="true"
							filterBy="name"
							[style]="{'width':'100%'}"
						></p-select>
					</div>
				}
			</div>
			<!-- OBSERVATIONS -->
			<div class="row justify-content-start mt-3">
				<div class="col-12">
					<label for="fine-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'general.observations' | translate }}
					</label>
					<textarea
						rows="2"
						pInputTextarea
						[pTooltip]="entity.observations"
						tooltipPosition="top"
						[(ngModel)]="entity.observations"
						class="observations"
					></textarea>
				</div>
			</div>

			<div class="row mt-4 mb-4">
				<!-- HEIGHT-->
				@if (selectedType?.id == 5) {
					<div class="col-sm-6">
						<label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ 'tableManagement.versions.height' | translate }}
						</label>
						<div class="input-wrapper">
							<input
								type="number"
								id="vehicle-data-settings-name"
								class="form-control custom-input mid-input"
								[(ngModel)]="entity.height"
							/>
						</div>
					</div>
				}

				<!-- WEIGHT -->
				@if (selectedType?.id == 5) {
					<div class="col-sm-6">
						<label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ 'tableManagement.versions.weight' | translate }}
						</label>
						<div class="input-wrapper">
							<input
								type="number"
								id="vehicle-data-settings-name"
								class="form-control custom-input short-input"
								[(ngModel)]="entity.weight"
							/>
						</div>
					</div>
				}
			</div>

			@if (selectedType?.id == 5) {
				<div class="row mt-4 mb-4">
					<div class="col-sm-12">
						<label for="vehicle-data-settings-url" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ 'tableManagement.versions.url' | translate }}
						</label>
						<div class="d-flex align-items-start gap-2">
							<textarea
								id="vehicle-data-settings-url"
								rows="3"
								cols="80"
								pInputTextarea
								[(ngModel)]="entity.url"
								class="form-control custom-input flex-grow-1"
							></textarea>
							<button
								class="btn custom-button"
								type="button"
								[disabled]="!entity.url"
								(click)="entity.url && openUrl(entity.url)"
							>
								<i class="pi pi-external-link"></i>
							</button>
						</div>
					</div>
				</div>
			}

			<!-- ROW 4 -->
			@if (!isNew) {
				<div class="row mt-3">
					<div class="col-12">
						<label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ 'general.enabled' | translate }}
						</label>
						<input
							class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
							type="checkbox"
							[(ngModel)]="enabledModel"
							[disabled]="true"
						/>
					</div>
				</div>
			}
		</div>
	</div>
</div>
<ng-template pTemplate="footer">
		<div class="d-flex justify-content-center gap-2 w-100">
			@if (isNew) {
				<button class="btn custom-button" (click)="save()" i18n>
					{{ 'general.create' | translate }}
				</button>
			}
			@if (!isNew) {
				<button class="btn custom-button" (click)="save()" [disabled]="!canUpdate" i18n>
					{{ 'general.save' | translate }}
				</button>
				<button class="btn custom-button" (click)="changeStatus(!entity.disabled)" [disabled]="!canDisable" i18n>
					{{ 'general.changeStatus' | translate }}
				</button>
			}
		</div>
	</ng-template>
</p-dialog>
